'use strict';
const GoldFileListModel = require('../../models/gold-file-list-model'),
	GoldFileListPreferences = require('../../models/gold-file-list-preferences'),
	mmWidgets = require('../../widgets/mm-widgets');

module.exports = function goldFileListStart(config, storage, fileModel, navigatorShim) {
	if (!config || !storage || !fileModel || !navigatorShim) {
		throw new Error('invalid-args');
	}
	const goldFileListPreferences = new GoldFileListPreferences(storage),
		goldFileListModel = new GoldFileListModel(goldFileListPreferences, fileModel, config.editorUrl, navigatorShim);

	return {
		goldFileListModel,
		goldFileListPreferences,
		initialiseWidgets: (authenticationModel) => {
			require('../../widgets/gold-file-list-widget');
			mmWidgets('[data-mm-role~="fileList"]').goldFileListWidget(config, goldFileListModel, authenticationModel, navigatorShim);

			require('../../widgets/gold-files-tag-nav-widget');
			mmWidgets('[data-mm-role~="fileTagNavigator"]').goldFileTagNavWidget(goldFileListModel);

			require('../../widgets/find-file-widget');
			mmWidgets('#findFile').findFileWidget(config.editorUrl, goldFileListModel, navigatorShim);

			require('../../widgets/dispatched-event-toggle-widget');
			mmWidgets('[data-mm-gold-file-list-context]').dispatchedEventToggleWidget(goldFileListModel, ['context'], 'data-mm-gold-file-list-context', 'context-value', 'context-toggle-class');

			require('../../widgets/file-tags-widget');
			mmWidgets('[data-mm-role~="file-tags-list"]').fileTagsWidget(goldFileListModel);

			require('../../widgets/selected-tag-filter-widget');
			mmWidgets('[data-mm-role~="selected-tag-filter"]').selectedTagFilterWidget(goldFileListModel);

		}
	};
};
